const DEVELOPMENT = {
    BASE_URL: 'http://api.dhwarco.com/api/v1/'
};

const PRODUCTION = {};

export default DEVELOPMENT;
